<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="header">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio1 || (showdettaglio5)) && showdettaglio3">
                                
                                <b-row class="my-1">
                                    <b-col sm="3">
                                        <label v-if="sconto.tipo == 'E'" for="scheda">Evento:</label>
                                        <label v-if="sconto.tipo == 'I'" for="scheda">Impianto:</label>
                                    </b-col>
                                    <b-col sm="9">                                        
                                        <b-form-input v-model="schedaVis" id="scheda" type="text" disabled></b-form-input>                                           
                                    </b-col>
                                </b-row>
                                
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="descrizione">Descrizione:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="parametri.flgpagamenti != 'S'" v-model="sconto.descrizione" id="descrizione" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                         
                                <b-row  class="my-1">
                                    <b-col sm="3"><label for="importoacconto">Importo acconto:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group prepend="€">
                                            <b-form-input :disabled="parametri.flgpagamenti != 'S'" v-model="sconto.importoacconto" id="importoacconto" type="number"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                <b-row  class="my-1">
                                    <b-col sm="3"><label for="importosaldo">Importo saldo:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group prepend="€">
                                            <b-form-input :disabled="parametri.flgpagamenti != 'S'" v-model="sconto.importosaldo" id="importosaldo" type="number"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flgsocio">Profilo soci:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="sconto.flgsocio" :options="options_profilosconti" id="flgsocio">

                                        </b-form-select>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="sconto.datainizio != null">
                                    <b-col sm="3"><label for="datainizio">Data inizio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="parametri.flgpagamenti != 'S'" v-model="sconto.datainizio" id="datainizio" type="date"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="sconto.datafine != null">
                                    <b-col sm="3"><label for="datafine">Data fine:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="parametri.flgpagamenti != 'S'" v-model="sconto.datafine" id="datafine" type="date"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="note">Note:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea :disabled="parametri.flgpagamenti != 'S'" id="note" v-model="sconto.note" :rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="sconto.id != null">
                                    <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input disabled v-model="sconto.datains" id="datains" type="text"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="sconto.id != null">
                                    <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input disabled v-model="sconto.uteins" id="uteins" type="text"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="sconto.id != null">
                                    <b-col sm="3"><label for="datamod">Data modifica:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input disabled v-model="sconto.datamod" id="datamod" type="text"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="sconto.id != null">
                                    <b-col sm="3"><label for="utemod">Utente modifica:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input disabled v-model="sconto.utemod" id="utemod" type="text"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-3" v-if="parametri.flgpagamenti == 'S'">
                                    <b-col sm="6" offset-sm="3">
                                        <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                            <div v-if="sconto.id != null">
                                                Salva
                                            </div>
                                            <div v-else>
                                                Inserisci
                                            </div>
                                        </b-button>
                                    </b-col>
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>

                </b-card>
            </b-col>
        </b-row>
    </b-container>



</div>
</template>

<script>
import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    Partecipa,
    Categoria,
    Socio,
    Visibilità
} from '../classes.js'

import {
    ctrlVismenu
} from '../util.js'



export default {
    name: 'appdettaglio',
    data: function () {
        return {                        
            namespace: NAMESPACE, 
            sconto: {
                id: this.$route.params.id,
                id_scheda: this.$route.params.id_scheda,
                tipo: this.$route.params.tipo,
                importoacconto: 0,
                importosaldo: 0,
                datainizio: '',
                datafine: '',
                note: '',
                descrizione: '',
                flgsocio: 'T',
                datains: null,
                datamod: null,
                uteins: '',
                utemod: '',
                titoloscheda: '',
            },            
            parametri: null,
            options: [],
            options_profilosconti: [],
            error: '',
            showerror: false,
            showdettaglio1: false,
            showdettaglio3: false,
            showdettaglio5: false,
            datamin: null,
            datamax: null,
            dismissSecs: 2,
            dismissCountDown: 0,                      
        };
    },
    computed:{
        header: {
            // getter
            get: function () {
                var aux = "";
                if(this.sconto.id == null){
                    aux += "Nuovo sconto";                    
                }
                else{
                    aux += "Sconto #" + this.sconto.id;
                } 
                
                if(this.sconto.id_scheda != null && this.sconto.tipo == 'E'){
                    aux += ' - Evento #' + this.sconto.id_scheda;
                }
                else if(this.sconto.id_scheda != null && this.sconto.tipo == 'I'){
                    aux += ' - Impianto #' + this.sconto.id_scheda;
                }

                return aux;                
            },
            // setter
            set: function (newValue) {

            }
        },
        schedaVis: {
            // getter
            get: function () {
                if(this.sconto.id_scheda == null || this.sconto.id_scheda == 'null' || parseInt(this.sconto.id_scheda) <= 0){
                    return '';
                }
                else{
                    return this.sconto.titoloscheda;
                }
                
            },
            // setter
            set: function (newValue) {

            }
        },
    },
    methods: {  
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        }, 
        getProfiliSconti() {

            var sc = new Socio();
            var tipi = sc.getListaProfiliSconti();
            var keys = Object.keys(tipi);
            var options = [];
            for (var i = 0; i < keys.length; i++) {
                options.push({
                    value: keys[i],
                    text: tipi[keys[i]]
                });
            }

            return options;

        },
        insert() {

                var appdettaglio = this;

                if (this.sconto.descrizione == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo descrizione vuoto!";

                } else if (this.sconto.datainizio == "" || parseInt(this.sconto.datainizio) == 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo data inizio vuoto!";

                } else if (this.sconto.datafine == "" || parseInt(this.sconto.datafine) == 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo data fine vuoto!";

                } else if (this.sconto.datafine < this.sconto.datainizio) { //sono stringhe yyyy-mm-dd
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Data inizio maggiore di data fine!";

                } else if (this.sconto.importoacconto < 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Importo acconto < 0!";

                } else if (this.sconto.importosaldo < 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Importo saldo < 0!";

                } else if (this.sconto.importosaldo == 0 && this.sconto.importoacconto == 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Importo saldo e importo acconto entrambi uguali a 0!";

                } else {

                    var json = JSON.stringify(this.sconto);

                    //console.log(json);

                    var token = localStorage.getItem('token');
                    this.axios.post(NAMESPACE + 'rest/sconto', json, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {
                                        this.showpassword = false;
                                        this.sconto = res[0];
                                        this.showerror = false;
                                        this.showdettaglio1 = true; //anche se non dovrebbe servire                                 
                                        this.dismissCountDown = this.dismissSecs;

                                        this.$router.replace('/app/dettagliosconto/' + this.sconto.id);

                                        setTimeout(function() {
                                            //window.history.back();
                                            appdettaglio.$router.go(-1);
                                        }, 2500);

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }


                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                appdettaglio.showerror = true;
                                appdettaglio.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });
                }

            }

    },
    created: function () {  

        

            if(!ctrlVismenu("S")){
                this.$router.replace('/accessdenied');
                return;
            }

        
            this.options_profilosconti = this.getProfiliSconti();

            var id = this.sconto.id; //se è la prima volta si prova a prendere da getid 

            var appdettaglio = this;

            if (id != null) {

                var token = localStorage.getItem('token');                

                this.axios.get(NAMESPACE + 'rest/sconti/' + id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.sconto = res[0];
                                    this.showdettaglio1 = true;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }
            else{

                if(this.sconto.tipo == 'E'){

                    var token = localStorage.getItem('token');                

                    this.axios.get(NAMESPACE + 'rest/eventi/' + this.sconto.id_scheda, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {
                                        this.sconto.titoloscheda = res[0].titolo;
                                        this.showdettaglio5 = true;

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }


                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                appdettaglio.showerror = true;
                                appdettaglio.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });

                }
                else if(this.sconto.tipo == 'I'){ //in realtà attualmente non è possibile inserire sconti su impianti

                    var token = localStorage.getItem('token');                

                    this.axios.get(NAMESPACE + 'rest/impianti/' + this.sconto.id_scheda, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {
                                        this.sconto.titoloscheda = res[0].nominativo;
                                        this.showdettaglio5 = true;

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }


                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                appdettaglio.showerror = true;
                                appdettaglio.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });

                }


                   
            }
            
            //PAREMETRI
            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + 'rest/cral', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            //alert("Ret: " + JSON.stringify(res))
                            if (typeof res == "object") {

                                this.parametri = res;
                                this.showdettaglio3 = true;

                            } else {
                                throw new Error("Errore parametri non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

            

    },
        mounted: function() {
            
          
            
        }

}
</script>
